export const formContentStyle = {
	wrapper: {
		marginBottom: '48px',
	},

	title: {
		marginBottom: '4px',
	},

	addressTitle: {
		display: 'flex',
		alignItems: 'center',

		'& .MuiTypography-subtitle1': {
			paddingRight: '4px',
		},

		'& .MuiTypography-body1': {
			color: 'var(--neutral-400)',
		},

		'@media (max-width: 767.98px)': {
			display: 'none',
		},
	},

	content: {
		display: 'flex',
		flexDirection: 'column',
		gap: '8px',
		padding: '16px',
		borderRadius: 'var(--default--border-radius)',
		border: '1px solid var(--neutral-100)',
		backgroundColor: 'var(--neutral-50)',
		marginBottom: '24px',

		'@media (max-width: 639.98px)': {
			border: 'none',
			padding: '0',
		},
	},

	item: {
		display: 'flex',
		gap: '24px',
	},

	itemField: {
		width: '100%',
	},
};
